var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{attrs:{"value":"tab1","type":"card"},on:{"tab-click":_vm.changeTab}},[_c('el-tab-pane',{attrs:{"label":"控制柜料号","name":"tab1"}},[_c('thk-material-box-list',{ref:"tabBox"})],1),_c('el-tab-pane',{attrs:{"label":"马达额定转速","name":"tab2"}},[_c('thk-material-zhuansu-list',{ref:"tabZhuansu"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }